export const FREE_ORDER_PAYMENT_TOKEN = "free_order";

const INVALID_TOKEN_VALUES = new Set(["", "0", "undefined", "null"]);

/** First non-empty string that is not "", "0", "undefined", or "null". */
export function firstValidToken(...candidates) {
  for (const value of candidates) {
    if (value == null) continue;
    const token = String(value).trim();
    if (!INVALID_TOKEN_VALUES.has(token)) {
      return token;
    }
  }
  return "";
}

function readFreeOrderFlag(obj) {
  if (!obj || typeof obj !== "object") return false;
  return obj.free_order === true || obj.freeOrder === true;
}

/** true if API returns free_order / freeOrder on raw, raw.data, or raw.result */
export function detectFreeOrderFromPaymentIntent(raw) {
  if (!raw || typeof raw !== "object") return false;
  return (
    readFreeOrderFlag(raw) ||
    readFreeOrderFlag(raw.data) ||
    readFreeOrderFlag(raw.result)
  );
}

/** payment_intent_id / payment_token from response, else "free_order" */
export function extractFreeOrderPaymentToken(raw) {
  if (!raw || typeof raw !== "object") {
    return FREE_ORDER_PAYMENT_TOKEN;
  }

  const nested = [raw, raw.data, raw.result];
  for (const obj of nested) {
    if (!obj || typeof obj !== "object") continue;
    const token = firstValidToken(
      obj.payment_intent_id,
      obj.payment_token,
      obj.paymentIntentId,
      obj.paymentToken
    );
    if (token) return token;
  }

  return FREE_ORDER_PAYMENT_TOKEN;
}

/** contact_details_id from response if present */
export function extractContactDetailsIdFromPaymentIntent(raw) {
  if (!raw || typeof raw !== "object") return null;

  const nested = [raw, raw.data, raw.result];
  for (const obj of nested) {
    if (!obj || typeof obj !== "object") continue;
    const id = firstValidToken(obj.contact_details_id, obj.contactDetailsId);
    if (id) return id;
  }

  return null;
}

/** token is non-empty and not "0" / "undefined" / "null" */
export function isValidOrderPaymentToken(token) {
  if (token == null) return false;
  const value = String(token).trim();
  return !INVALID_TOKEN_VALUES.has(value);
}
